"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrmStatus = void 0;
var CrmStatus;
(function (CrmStatus) {
    CrmStatus["NEW"] = "new";
    CrmStatus["INVITED"] = "invited";
    CrmStatus["PENDING_APPROVAL"] = "pending-approval";
    CrmStatus["DECLINED"] = "declined";
    CrmStatus["REGISTERED"] = "registered";
    CrmStatus["REGISTRATION_IN_PROGRESS"] = "registration-in-progress";
    CrmStatus["WAITLIST"] = "waitlist";
    CrmStatus["ARRIVED"] = "arrived";
    CrmStatus["NOSHOW"] = "no-show";
    CrmStatus["CANCELLED"] = "cancelled";
})(CrmStatus || (exports.CrmStatus = CrmStatus = {}));
